export default {
  // 保存新房地图数据
  saveNewRealMarkers(id) {
    let that = this;
    if (!id) {
      that.$message.error("保存失败，请联系开发人员");
      return;
    }
    let obj = {
      id: id,
    };
    let markObj = that.realMarkers[id];
    if (markObj) {
      obj.move = markObj.line[1].join("|");
    } else {
      obj.move = "";
    }
    let estateMap = {
      杭州: "WpRealEstateModel",
      苏州: "SzEstateModel",
    };
    let param = {
      db: estateMap[that.$store.state.Counter.city],
      model: "edit",
      item: JSON.stringify(obj),
    };
    that.$axios
      .post(that.$url_prefix + "updateData", param)
      .then(function (res) {
        console.log("save map data", res);
        that.$message({
          message: "保存地图数据成功",
          type: "success",
        });
      })
      .catch(function (res) {
        console.log("save map data fail", res);
      });
  },

  // 保存学区地图数据
  saveNewSchoolMarkers(id) {
    let that = this;
    if (!id) {
      that.$message.error("保存失败，请联系开发人员");
    }

    let move = that.schoolMarkers[id].line[1].join("|");
    let obj = {
      id: id,
      move: move,
    };

    that.$axios
      .post(that.$url_prefix + "updateSchoolData", obj)
      .then(function (res) {
        console.log("save map data", res);
        that.$message({
          message: "保存地图数据成功",
          type: "success",
        });
      })
      .catch(function (res) {
        console.log("save map data fail", res);
      });
  },

  // 保存二手房地图数据
  saveOldRealMarkers() {
    let that = this;
    let obj = {
      id: "d0gd9j6xwh",
      data: JSON.stringify(that.realMarkers),
    };
    let param = {
      db: "WpBackupModel",
      model: "edit",
      item: JSON.stringify(obj),
    };
    that.$axios
      .post(that.$url_prefix + "updateData", param)
      .then(function (res) {
        console.log("save map data", res);
        that.$message({
          message: "保存地图数据成功",
          type: "success",
        });
      })
      .catch(function (res) {
        console.log("save map data fail", res);
      });
  },

  // 保存新房地图数据
  saveLandMarkers(id) {
    let that = this;
    if (!id) {
      that.$message.error("保存失败，请联系开发人员");
      return;
    }
    let obj = {
      id: id,
    };
    let markObj = that.landMarkers[id];
    if (markObj) {
      obj.move = markObj.line[1].join("|");
    } else {
      obj.move = "";
    }
    let landMap = {
      杭州: "LandDealModel",
      苏州: "SzLandDealModel",
    };
    let param = {
      db: landMap[that.$store.state.Counter.city],
      model: "edit",
      item: JSON.stringify(obj),
    };
    that.$axios
      .post(that.$url_prefix + "updateData", param)
      .then(function (res) {
        console.log("save map data", res);
        that.$message({
          message: "保存地图数据成功",
          type: "success",
        });
      })
      .catch(function (res) {
        console.log("save map data fail", res);
      });
  },

  changeAreaCenter(id, center) {
    let that = this;
    if (id && center) {
      let obj = {
        id: id,
        kernel: center,
      };
      let areaMap = {
        杭州: "WpAreaModel",
        苏州: "SzAreaModel",
      };
      let param = {
        db: areaMap[that.$store.state.Counter.city],
        model: "edit",
        item: JSON.stringify(obj),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(function (res) {
          console.log("change area center back", res);
          that.$message({
            message: "更改板块标注点成功",
            type: "success",
          });
        })
        .catch(function (res) {
          console.log("change area center fail", res);
        });
    } else {
      that.$message.error("保存失败，请联系开发人员");
    }
  },
}



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/methods/bindHandler.js